import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { getStyledText } from '../../helpers/styled';
export var CardContainer = withTheme(styled.div.withConfig({
  displayName: "style__CardContainer",
  componentId: "sc-m550uv-0"
})(function (_ref) {
  var coreTheme = _ref.coreTheme,
      shadow = _ref.shadow,
      radius = _ref.radius,
      padding = _ref.padding,
      autoHeight = _ref.autoHeight;
  return css(["font-family:", ";position:relative;background-color:", ";overflow:hidden;box-shadow:", ";border-radius:", ";display:inline-block;width:100%;height:", ";", "{padding:", ";}"], coreTheme.ff_sec_regular, coreTheme.cl_white, shadow, radius, autoHeight ? 'auto' : '100%',
  /* sc-selector */
  Content, padding);
}));
export var Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-m550uv-1"
})(["width:auto;"]);
var ratios = {
  '3:2': '66.6%',
  '16:9': '56.25%',
  '1:1': '100%'
};
export var ImageWrapper = styled.div.withConfig({
  displayName: "style__ImageWrapper",
  componentId: "sc-m550uv-2"
})(["position:relative;width:100%;padding-top:", ";"], function (p) {
  return ratios[p.ratio || '16:9'];
});
export var Image = styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-m550uv-3"
})(["position:absolute;top:0;left:0;object-fit:cover;width:100%;height:100%;"]);
export var OverlayWrapper = withTheme(styled.div.withConfig({
  displayName: "style__OverlayWrapper",
  componentId: "sc-m550uv-4"
})(["", ""], function (_ref2) {
  var customStyle = _ref2.customStyle;
  return css(["position:absolute;bottom:0;left:0;width:100%;height:100%;background:", ";"], customStyle.background);
}));
export var TagWrapper = withTheme(styled.div.withConfig({
  displayName: "style__TagWrapper",
  componentId: "sc-m550uv-5"
})(["position:absolute;bottom:0;left:0;background-color:", ";opacity:0.7;padding:", "px ", "px;"], function (p) {
  return p.coreTheme.cl_pri_base;
}, function (p) {
  return p.coreTheme.space_1;
}, function (p) {
  return p.coreTheme.space_4;
}));
export var Tag = withTheme(getStyledText('smallBody', {
  lineHeight: 'compact'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n"])), function (p) {
  return p.coreTheme.cl_white;
}));
export var TitleWrapper = styled.div.withConfig({
  displayName: "style__TitleWrapper",
  componentId: "sc-m550uv-6"
})(["width:100%;display:flex;justify-content:left;align-items:center;"]);
export var Thumbnail = withTheme(styled.img.withConfig({
  displayName: "style__Thumbnail",
  componentId: "sc-m550uv-7"
})(["height:72px;width:72px;border-radius:", ";margin-right:", "px;", ""], function (p) {
  return p.coreTheme.rad_xs;
}, function (p) {
  return p.coreTheme.space_4;
}, function (p) {
  return p.showThumbnailBorder && css(["border:1px solid ", ";"], p.coreTheme.cl_ter_l5);
}));
export var getTitle = function getTitle(isHeavy) {
  return withTheme(getStyledText('header')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    line-height: 27px;\n    ", "\n  "])), !isHeavy && css(["font-family:", ";"], function (p) {
    return p.coreTheme.ff_sec_regular;
  })));
};
export var InfoWrapper = styled.div.withConfig({
  displayName: "style__InfoWrapper",
  componentId: "sc-m550uv-8"
})(["width:100%;display:flex;justify-content:left;align-items:top;"]);
export var IconWrapper = styled.div.withConfig({
  displayName: "style__IconWrapper",
  componentId: "sc-m550uv-9"
})(["padding-top:3px;"]);
export var Info = getStyledText('body', {
  lineHeight: 'compact'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-left: 8px;\n"])));
export var BodyWrapper = styled.div.withConfig({
  displayName: "style__BodyWrapper",
  componentId: "sc-m550uv-10"
})(["width:100%;"]);
export var BodyText = getStyledText('body', {
  lineHeight: 'compact'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
export var ViewMoreWrapper = withTheme(styled.div.withConfig({
  displayName: "style__ViewMoreWrapper",
  componentId: "sc-m550uv-11"
})(["padding-top:", "px;display:flex;align-items:center;cursor:pointer;width:fit-content;"], function (p) {
  return p.coreTheme.space_1;
}));
export var ViewMoreText = withTheme(getStyledText('link', {
  lineHeight: 'compact'
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-right: ", "px;\n"])), function (p) {
  return p.coreTheme.space_2;
}));
export var FooterWrapper = styled.div.withConfig({
  displayName: "style__FooterWrapper",
  componentId: "sc-m550uv-12"
})(["width:100%;display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:center;"]);
export var FooterText = withTheme(getStyledText('body', {
  lineHeight: 'compact'
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: ", "px;\n"])), function (p) {
  return p.coreTheme.space_4;
}));
export var FooterButton = styled.div.withConfig({
  displayName: "style__FooterButton",
  componentId: "sc-m550uv-13"
})(["align-self:center;"]);
export var IconListWrapper = withTheme(styled.div.withConfig({
  displayName: "style__IconListWrapper",
  componentId: "sc-m550uv-14"
})(["display:flex;align-items:center;"]));
export var IconListItem = withTheme(styled.div.withConfig({
  displayName: "style__IconListItem",
  componentId: "sc-m550uv-15"
})(["height:", ";width:", ";border-radius:", ";overflow:hidden;img,svg{width:100%;height:100%;}@media (max-width:", "){width:48px;height:48px;}"], function (props) {
  var _props$coreTheme$card, _props$coreTheme$card2;

  return ((_props$coreTheme$card = props.coreTheme.card) === null || _props$coreTheme$card === void 0 ? void 0 : (_props$coreTheme$card2 = _props$coreTheme$card.iconList) === null || _props$coreTheme$card2 === void 0 ? void 0 : _props$coreTheme$card2.height) || '56px';
}, function (props) {
  var _props$coreTheme$card3, _props$coreTheme$card4;

  return ((_props$coreTheme$card3 = props.coreTheme.card) === null || _props$coreTheme$card3 === void 0 ? void 0 : (_props$coreTheme$card4 = _props$coreTheme$card3.iconList) === null || _props$coreTheme$card4 === void 0 ? void 0 : _props$coreTheme$card4.width) || '56px';
}, function (p) {
  return p.coreTheme.rad_xs;
}, function (p) {
  return p.coreTheme.brk_sm;
}));